import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles({
  root: {
    color: '#000',
    fontFamily: '"proxima nova", sans-serif',
    fontSize: '2.5rem',
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 600,
    letterSpacing: 'normal',
    lineHeight: 1.6,
    width: '450px',
    '@media (max-width: 575px)': {
      width: '100%',
    },
  },
});

const LoginHeading = ({ text = '' }) => {
  const classes = useStyles();

  return <p className={classes.root}>{text}</p>;
};

export default LoginHeading;
